// Third-party
import React from 'react';

// Components
import { CancelButton, CloseButton } from '../buttons';
import Modal from '@/views/components/modals/AccessibleModal';

// Constants and types
import { MODAL_SIZES } from '@/utils/constants';

// Utils
import { FormattedMessage } from '../../../utils/i18n';
import { Typography } from '@capintel/component-lib/typography';
import { ALLOWED_HTML_TAGS } from '../i18n/FormattedMessageV2';

type Props = {
  showModal: boolean;
  onCancel: () => void;
  children: React.ReactNode;
};

/**
 * A modal used to capture extra details to add to the proposal branding
 */
const DownloadProposalFormModal = (props: Props) => {
  const { showModal, onCancel, children } = props;

  return (
    <Modal
      show={showModal}
      className="download-proposal-form-modal"
      onHide={onCancel}
      dialogClassName="modal-dialog-centered"
      backdrop="static"
      size={MODAL_SIZES.SM}
    >
      <Modal.Header className="d-flex flex-column align-items-start">
        <FormattedMessage tagName="h1" id="Proposal.DownloadProposalFormModal.Title" />

        <Typography as={ALLOWED_HTML_TAGS.H2} variant="bodyMdRegular">
          <FormattedMessage id="Proposal.DownloadProposalFormModal.SubTitle" />
        </Typography>

        {!!props.onCancel && <CloseButton onClick={props.onCancel} />}
      </Modal.Header>

      {children}

      <CancelButton onClick={onCancel} />
    </Modal>
  );
};

export default DownloadProposalFormModal;
